import React, { useState } from 'react';
import styles from '../styles/components/SimpleQuestionPreview.module.css';
import QuestionSchema from '@ax2/common/model/schemas/QuestionSchema';
import { getQuestionBuilder } from '../helpers/questionsBuilder';
import AnswerData from '@ax2/common/model/answers-data/AnswerData';
import Stepper from '@ax2/common/components/Stepper';
import { ActionButton } from '@ax2/common/components/ActionButton';
import useMediaQuery from '@ax2/common/helpers/hooks/useMediaQuery';
import breakpoints from '@ax2/common/styles/Breakpoints.module.css';

export interface SimpleQuestionsPreviewData {
  questions: QuestionSchema[];
  answers: AnswerData[];
}

export const SimpleQuestionsPreview: React.FC<SimpleQuestionsPreviewData> = ({
  questions,
  answers,
}) => {
  const [step, setStep] = useState(0);
  const question = questions[step];
  const answer = answers[step];
  const isLgBreakpoint = useMediaQuery(breakpoints.lg);
  const isDesktop = isLgBreakpoint !== false;
  return (
    <div className={styles.previewContainer}>
      <div className={styles.stepperContainer}>
        <Stepper
          labels={questions.map((_q, i) => `Q${i + 1}`)}
          step={step}
          onCompletion={s => {
            if (s < step) {
              setStep(s);
            }
          }}
        />
      </div>
      <div className={styles.questionContainer}>
        {getQuestionBuilder(question, isDesktop, 'Q1').getQuestion(
          answer,
          () => {}
        )}
      </div>
      <div className={styles.actionsContainer}>
        <ActionButton
          text="Back"
          type="secondary"
          disabled={step < 1}
          onClick={() => {
            setStep(step - 1);
          }}
        />
        <ActionButton
          text="Next"
          type="secondary"
          disabled={step >= questions.length - 1}
          onClick={() => {
            setStep(step + 1);
          }}
        />
      </div>
    </div>
  );
};
